export const purchaseOrderIntentHeaderElements = [
  { label: "Fecha solicitud", value: "displayFechaSolicitud", align: "inherit" },
  { label: "N° solicitud", value: "id", align: "inherit" },
  { label: "Titular cuenta", value: "displayTitularCuenta", align: "inherit" },
  { label: "Zona comercial", value: "zonaComercial", align: "inherit" },
  { label: "Tipo de insumo", value: "tipoInsumo", align: "inherit" },
  { label: "Estado", value: "displayEstado", align: "inherit" },
];
